/** Ecoprism brand palette — shared by anomaly UI */
export const ANOMALY_THEME = {
  primaryTeal: "#407775",
  lightTeal: "#6F9896",
  paleTeal: "#DAECEC",
  gold: "#FAB430",
  warmGold: "#C9922A",
  coral: "#E8927C",
  mutedRed: "#B85C5C",
  darkText: "#494949",
  grayText: "#707070",
  background: "#F5F5F5",
  cardBorder: "#E5E5E5",
  cream: "#FCF7EE",
};

export const SEVERITY_STYLES = {
  CRITICAL: {
    background: "#FCE8EA",
    color: "#cc2229",
  },
  HIGH: {
    background: "#FFF6E6",
    color: "#FAB430",
  },
  MEDIUM: {
    background: "#DAECEC",
    color: "#407775",
  },
  LOW: {
    background: ANOMALY_THEME.background,
    color: ANOMALY_THEME.grayText,
  },
  INSUFFICIENT_HISTORY: {
    background: "#F0F0F0",
    color: "#666666",
  },
};

export const severityStyle = (severity) =>
  SEVERITY_STYLES[severity] || SEVERITY_STYLES.HIGH;

/** Detection type labels for display */
export const DETECTION_TYPE_LABELS = {
  same_month_baseline: "Same-Month Baseline",
  period_over_period: "Period-Over-Period",
  year_over_year: "Year-Over-Year",
  data_quality: "Data Quality",
};

export const getDetectionTypeLabel = (type) =>
  DETECTION_TYPE_LABELS[type] || type || "Unknown";
